import { default as Form } from './Form';

export default Form;